export const getChecklistStatusChipProps = (status: string): { label: string; color: string; outlined: boolean } => {
  switch (status) {
    case 'active':
      return { label: 'aktywna', color: '#2E7D32', outlined: false };
    case 'inactive':
      return { label: 'nieaktywna', color: '#D32F2F', outlined: true };
    case 'planned_deactivation':
      return { label: 'do wyłączenia', color: '#F57C00', outlined: true };
    default:
      return { label: status, color: '#757575', outlined: false };
  }
};
